import type { ReactNode } from 'react';
import type { CrawlJobPeriodCountDTO } from '@liks/lac-svc-api/esm/models/index';
import type { CostChartViewMode } from '../../costs/costChartTypes';

export const LAC_CRAWL_JOB_TIME_SERIES_CHART_HEIGHT = 200;

export type LacCrawlJobTimeSeriesChartProps = {
  mode: CostChartViewMode;
  onModeChange: (mode: CostChartViewMode) => void;
  fromDay: string;
  toDay: string;
  fromMonth: string;
  toMonth: string;
  rangeLabel: string;
  canGoNext: boolean;
  onPrev: () => void;
  onNext: () => void;
  query: {
    data?: CrawlJobPeriodCountDTO[];
    isLoading: boolean;
    isError: boolean;
  };
  stackedByTenant?: boolean;
  tenantLabels?: Record<string, string>;
  aside?: ReactNode;
};

export function formatCrawlJobPeriodLabel(
  label: string,
  mode: CostChartViewMode,
  locale: string,
) {
  if (mode === 'daily') {
    return new Date(`${label}T00:00:00`).toLocaleDateString(locale, {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }
  return new Date(`${label}-01T00:00:00`).toLocaleDateString(locale, {
    month: 'long',
    year: 'numeric',
  });
}

export function resolveCrawlJobChartYMax(
  chartData: Array<Record<string, string | number>>,
  stackedByTenant: boolean,
): number | undefined {
  if (chartData.length === 0) {
    return undefined;
  }
  const max = stackedByTenant
    ? Math.max(
        ...chartData.map((point) =>
          'total' in point ? Number(point.total) : 0,
        ),
      )
    : Math.max(
        ...chartData.map((point) =>
          'count' in point ? Number(point.count) : 0,
        ),
      );
  return Math.max(Math.ceil(max * 1.1), 1);
}
